import { useState, useContext, useEffect } from "react";

import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";

import "./Products.css";

const Products = ({ search }) => {
  const { addToCart, removeFromCart, cart, updateQty } =
    useContext(CartContext);

  const [products, setProducts] = useState([]);
  const [qtyMap, setQtyMap] = useState({});
  const [loading, setLoading] = useState(true);

  /* FETCH PRODUCTS */
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      const querySnapshot = await getDocs(collection(db, "products"));

      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setProducts(data);
      setLoading(false);
    };

    fetchProducts();
  }, []);

  /* SYNC CART QTY */
  useEffect(() => {
    setQtyMap((prev) => {
      const updated = { ...prev };

      cart.forEach((item) => {
        updated[item.id] = item.qty || 1;
      });

      return updated;
    });
  }, [cart]);

  /* UPDATE CART */
  useEffect(() => {
    Object.keys(qtyMap).forEach((id) => {
      const itemInCart = cart.find((item) => item.id === id);

      if (itemInCart && itemInCart.qty !== qtyMap[id]) {
        updateQty(id, qtyMap[id]);
      }
    });
  }, [qtyMap]);

  /* FILTER PRODUCTS */
  const filteredProducts = products.filter((item) =>
    item.name
      .toLowerCase()
      .includes((search || "").toLowerCase().trim())
  );

  /* INCREASE QTY */
  const increase = (id) => {
    setQtyMap((prev) => ({
      ...prev,
      [id]: (prev[id] || 1) + 1,
    }));
  };

  /* DECREASE QTY */
  const decrease = (id) => {
    setQtyMap((prev) => ({
      ...prev,
      [id]: Math.max(1, (prev[id] || 1) - 1),
    }));
  };

  /* ADD TO CART */
  const handleAddToCart = (item) => {
    const qty = qtyMap[item.id] || 1;
    addToCart(item, qty);
  };

  /* CHECK CART */
  const isInCart = (id) => {
    return cart.some((item) => item.id === id);
  };

  /* LOADING */
  if (loading) {
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>
        Loading products...
      </p>
    );
  }

  return (
    <div className="products-container">
      <div className="products-grid">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item) => {
            const qty = qtyMap[item.id] || 1;

            return (
              <div className="product-card" key={item.id}>

                {/* PRODUCT BADGE */}
                <div className="product-badge"></div>

                <Link to={`/product/${item.id}`}>
                  <img
                    src={`${
                      item.image || item.images?.[0]
                    }?w=400&auto=format&fit=crop&q=80`}
                    alt={item.name}
                    loading="lazy"
                    onLoad={(e) =>
                      e.target.classList.add("loaded")
                    }
                  />

                  <h4>{item.name}</h4>

                  <p className="desc">
                    {item.description}
                  </p>

                  <p>£{item.price}</p>

                </Link>

                {/* QTY */}
                <div className="qty-box">
                  <button onClick={() => decrease(item.id)}>
                    -
                  </button>

                  <span>{qty}</span>

                  <button onClick={() => increase(item.id)}>
                    +
                  </button>
                </div>

                {/* ADD BUTTON */}
                <button
                  className="add-btn"
                  onClick={() => handleAddToCart(item)}
                >
                  Add to Cart
                </button>

                {/* REMOVE BUTTON */}
                {isInCart(item.id) && (
                  <button
                    className="remove-btn"
                    onClick={() => removeFromCart(item.id)}
                  >
                    Remove
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            No product found
          </p>
        )}
      </div>
    </div>
  );
};

export default Products;